
import Hex from "./HEX.vue";
import RGB from "./RGB.vue";

export default {
  name: "Preview",

  props: {
    red: Number,
    green: Number,
    blue: Number,
    alpha: Number,
    updateColor: Function
  },

  components: {
    Hex,
    RGB
  }
};
